var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-D---SFY---Personalise",
    transform: "translate(-267.000000, -684.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(119.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.453538,41 C150.311294,41 149.169049,41.4808572 148.294139,42.4425716 C146.56862,44.3660003 146.56862,47.4283013 148.294139,49.3517301 L155.147605,56.9948285 C155.34203,57.1972947 155.633667,57.1972947 155.828091,57.0201368 C155.828091,57.0201368 155.852395,56.9948285 155.852395,56.9948285 C158.136883,54.438693 160.421372,51.9078657 162.705861,49.3517301 C164.43138,47.4283013 164.43138,44.3660003 162.705861,42.4425716 C160.980343,40.5191428 158.136883,40.5191428 156.411365,42.4425716 L155.487848,43.4549025 L154.564332,42.4425716 C153.738027,41.4808572 152.595783,41 151.453538,41 L151.453538,41 Z M151.453538,41.9870226 C152.328449,41.9870226 153.20336,42.3666467 153.883846,43.1258949 L155.147605,44.5431582 C155.34203,44.7456244 155.633667,44.7456244 155.828091,44.5684665 C155.828091,44.5684665 155.852395,44.5431582 155.852395,44.5431582 L157.116154,43.1258949 C158.477127,41.6073986 160.615797,41.6073986 162.001072,43.1258949 C163.362044,44.6443913 163.362044,47.1499103 162.001072,48.6684067 C159.838099,51.0980009 157.675125,53.5022869 155.487848,55.9318811 L148.974625,48.6684067 C147.613653,47.1499103 147.613653,44.6443913 148.974625,43.1258949 C149.703717,42.3666467 150.578628,41.9870226 151.453538,41.9870226 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.42d7a32bab9b44f7c2c875113341e6fc.svg";
export { ForwardRef as ReactComponent };